module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-prologue element-without-heading full-character-formatting",
    attrs: {
      "id": "vol-1-prologue"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-prologue-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('b', [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("Welcome")]), _vm._v(" to Lucy’s first adventure!")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("With a million copies sold, readers can’t get enough of Lucy Guardino, everyone’s favorite Pittsburgh soccer mom turned kick-ass FBI agent!")]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-photograph inline-image-size-full inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "http://cjlyons.net",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Lucy Guardino FBI Thrillers",
      "src": "images/lucyfbivellum.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Don’t miss any of Lucy’s adventures:")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("SNAKE SKIN")]), _vm._v(", a USA Today Bestseller")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("BLOOD STAINED")]), _vm._v(", a USA Today Bestseller")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("KILL ZONE")]), _vm._v(", a Suspense Magazine Book of the Year")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("AFTER SHOCK")]), _vm._v(", a novella")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("HARD FALL")]), _vm._v(", Winner of the 2015 Thriller Award")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("BAD BREAK")]), _vm._v(", a novella")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("and Lucy’s NEW Beacon Falls Mysteries:")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("LAST LIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("DEVIL SMOKE")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("OPEN GRAVE")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://CJLyons.flexpub.com",
      "target": "_blank"
    }
  }, [_vm._v("GONE DARK")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("BITTER TRUTH")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("LESSER EVIL")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote-container prose without-attribution"
  }, [_c('blockquote', {
    staticClass: "prose without-attribution"
  }, [_c('div', {
    staticClass: "blockquote-image-block blockquote-image-aspect-wide"
  }, [_c('div', {
    staticClass: "blockquote-image-size-container"
  }, [_c('img', {
    staticClass: "blockquote-image-image",
    attrs: {
      "alt": "",
      "src": "images/blockquote-big-66-screen.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first blockquote-content blockquote-content-prose blockquote-position-first blockquote-position-last"
  }, [_vm._v("Everything a great thriller should be—action packed, authentic, and intense.” "), _c('i', [_vm._v("~Lee Child")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Want to be the first to have a chance to read the new books? Sign up for my "), _c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/LucyTWH",
      "target": "_blank"
    }
  }, [_vm._v("Thrillers with Heart newsletter HERE")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Be sure to open the Thrillers with Heart emails; they’ll arrive every few weeks with info on contests, new books, and exclusive offers for my readers!")]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-freestanding inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "http://cjlyons.net/signup",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Thanks for reading! CJ",
      "src": "images/image-300thanks-448.jpg"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24375fb7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol001prologue.vue
// module id = 72
// module chunks = 0